import { useAsyncExecutor } from "async-executor-hook";
import { addDays, differenceInDays, format, parse } from "date-fns";
import { useState } from "react";
import DatePicker from "react-date-picker";
import { getErrorValueResponse } from "../../common/error/Error";

import loadingGreen from "../../images/icon_loading_green.gif";
import IconWarning from "../../images/icon_warning.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Modal from "../Modal/Modal";
import {
  Container,
  DivDate,
  DivFlex,
  DivMessage,
  MainButton,
  Row,
  RowContainer,
} from "./VctVolanteEditionStyles";

export const LIMIT_DAYS_DATE = 4;
const messages = {
  additional_charges:
    "Esta opción no está disponible actualmente, por favor contáctese con el área de atención al cliente o acérquese de manera presencial a las ventanillas de facturación.",
  in_favor_charges:
    "Se generará un saldo a favor. Por favor acercarse de manera presencial a ventanilla a gestionar la emisión de su nota de crédito.",
};

// TODO: Check this component behaviour

function VctVolanteEdition(props) {
  const { volante, hideModal, showModalEdit } = props;
  const datenow = new Date();
  const dateToday = format(datenow, "yyyy-MM-dd");
  const [withdrawalDate, updateWithdrawalDate] = useState(dateToday);
  // Todo: pending changes
  const loadDateWithdrawal = useAsyncExecutor(
    (params: any) => {
      const { withdrawalDate, idVolante } = params;
      return networkBackendRequest(
        `/volantes/${idVolante}/`,
        HTTP_METHODS.PATCH,
        {},
        { withdrawal_date: withdrawalDate }
      ).then((response) => response.json());
    },
    {
      onSuccess: () => {
        hideModal();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        toggleGetModal();
      },
    }
  );

  const idVolante = volante.id;
  function saveChanges() {
    loadDateWithdrawal.execute({
      idVolante,
      withdrawalDate,
      additional_services: [],
    });
  }

  const [modalErrorDate, setModalErrorDate] = useState(false);
  const [disabledMessage, setDisabledMessage] = useState(false);
  const showModalDateError = () => {
    setModalErrorDate(!modalErrorDate);
  };
  const validDate = parse(volante.withdrawalDate, "yyyy-MM-dd", new Date());
  const [uploadDate, updateUploadDate] = useState(validDate);
  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);

  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  const uploadDateOnChange = (newDate) => {
    updateUploadDate(newDate);
    const date = new Date(newDate);
    const messageResult = differenceInDays(date, validDate);
    if (messageResult < 0) {
      setDisabledMessage(true);
    } else {
      setDisabledMessage(false);
    }
    const formatedDate = format(date, "yyyy-MM-dd");
    updateWithdrawalDate(formatedDate);
  };

  return (
    <Modal onOutsideClick={showModalEdit}>
      {modalErrorDate && (
        <ConfirmationModal
          message={"Atención la fecha escogida no es válida"}
          onAccept={showModalDateError}
          title={"Atención"}
          toggleModal={showModalDateError}
        />
      )}
      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            toggleGetModal();
          }}
          title={`Atención`}
          toggleModal={() => {
            toggleGetModal();
          }}
        />
      )}
      <Container>
        <h1>Volante Nº {volante.id}</h1>
        <RowContainer>
          <Row key={volante.id}>
            <h2>RETIRO</h2>
          </Row>
          <Row>
            <DivDate>
              <DatePicker
                className="clickable-element"
                value={uploadDate}
                onChange={uploadDateOnChange}
                clearIcon={null}
                dayPlaceholder={"dd"}
                locale={"es-PE"}
                monthPlaceholder={"mm"}
                showLeadingZeros={true}
                yearPlaceholder={"yy"}
                maxDate={addDays(new Date(), LIMIT_DAYS_DATE)}
                minDate={new Date()}
              />
            </DivDate>
          </Row>
          <DivMessage>
            <div className="warning-message">
              <img src={IconWarning} alt="warning" />
              <p>
                {" "}
                {disabledMessage
                  ? messages.in_favor_charges
                  : messages.additional_charges}
              </p>
            </div>
          </DivMessage>
        </RowContainer>
        <DivFlex>
          <MainButton onClick={() => saveChanges()} disabled={true}>
            {loadDateWithdrawal.isLoading && (
              <img
                src={loadingGreen}
                width="50"
                height="50"
                alt="Processing request"
              />
            )}
            {disabledMessage ? "Entendido" : "Guardar cambios"}
          </MainButton>
        </DivFlex>
      </Container>
    </Modal>
  );
}

export default VctVolanteEdition;
